import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { GridModule } from '@progress/kendo-angular-grid';
import { GapOverlapPageModule } from '../../validation/gap-overlap/gap-overlap.module';
import { DefaultPage } from './default-page';
import { ImplementerEmptyStatePageModule } from '../../implementer/implementer-empty-state/implementer-empty-state/implementer-empty-state-page.module';
import { DirectivesModule } from '../../../directives/directives.module';
import { PtKendoModule } from '../../../_foundation/kendo/modules/pt.kendo.module';

@NgModule({
  declarations: [
    DefaultPage,
  ],
    imports: [
        DirectivesModule,
        IonicPageModule.forChild(DefaultPage),
        GridModule,
        PtKendoModule,
        GapOverlapPageModule,
        ImplementerEmptyStatePageModule
    ],
  exports: [
    DefaultPage
  ]
})
export class DefaultPageModule {
}



// WEBPACK FOOTER //
// ./src/pages/default/default-page/default-page.module.ts